import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=a08c0b38&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08c0b38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a08c0b38')) {
      api.createRecord('a08c0b38', component.options)
    } else {
      api.reload('a08c0b38', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=a08c0b38&scoped=true&", function () {
      api.rerender('a08c0b38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dM0N2CKKLRo0/JS/comp/Accordion.vue"
export default component.exports